import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-quickloan-experian-report",
  templateUrl: "./quickloan-experian-report.component.html",
  styleUrls: ["./quickloan-experian-report.component.scss"],
})
export class QuickloanExperianReportComponent implements OnInit {
  @Input() experianResponse: any;
  experianData: any;
  creditProfileHeader: any;
  currentApplicationInformation: any;

  creditAccountSummaryDetails: any;
  currentBalanceAccountSummary: any;
  creditEnquirySummaryDetail: any;
  nonCreditEnquirySummaryDetail: any;
  summaryCreditAccountsArr: any;
  caisAccountHistory: any;
  months = [
    { id: 1, value: "Jan" },
    { id: 2, value: "Feb" },
    { id: 3, value: "Mar" },
    { id: 4, value: "Apr" },
    { id: 5, value: "May" },
    { id: 6, value: "Jun" },
    { id: 7, value: "Jul" },
    { id: 8, value: "Aug" },
    { id: 9, value: "Sep" },
    { id: 10, value: "Oct" },
    { id: 11, value: "Nov" },
    { id: 12, value: "Dec" },
  ];
  groupedData: any[] = [];
  needleRotation: number = 0;
  creditScoreExperian: any;
  customerDOB: any;
  customerGender: any;
  customerPhoneNumber: any;

  constructor() {}

  ngOnInit(): void {
    // this.experianData = this.experianResponse;
    // console.log("experian data in the compoennt", this.experianData);
    this.getExperionDataFunc();
  }

  getExperionDataFunc() {
    this.experianData = this.experianResponse;
    // console.log("experian data in the compoennt", this.experianData);

    this.customerDOB =
      this.experianData?.data?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.Date_Of_Birth_Applicant;

    this.customerPhoneNumber = this.experianData?.data?.mobile;

    // console.log("customerPhoneNumber", this.customerPhoneNumber);

    this.customerGender =
      this.experianData?.data?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS[0]?.CAIS_Holder_Details[0]?.Gender_Code;

    this.creditProfileHeader =
      this.experianData?.data?.credit_report?.CreditProfileHeader;

    this.currentApplicationInformation =
      this.experianData?.data?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details;

    this.creditScoreExperian = this.experianData?.data?.credit_score;

    this.creditAccountSummaryDetails =
      this.experianData?.data?.credit_report?.CAIS_Account?.CAIS_Summary?.Credit_Account;

    this.currentBalanceAccountSummary =
      this.experianData?.data?.credit_report?.CAIS_Account?.CAIS_Summary?.Total_Outstanding_Balance;

    this.creditEnquirySummaryDetail =
      this.experianData?.data?.credit_report?.CAPS?.CAPS_Summary;

    this.nonCreditEnquirySummaryDetail =
      this.experianData?.data?.credit_report?.NonCreditCAPS?.NonCreditCAPS_Summary;

    this.summaryCreditAccountsArr =
      this.experianData?.data?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS;

    this.caisAccountHistory =
      this.experianData?.data?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS?.map(
        (detail) => detail?.CAIS_Account_History
      );
    this.updateNeedle();
    this.groupAccountHistory();

    console.log("summaryCreditAccountsArr", this.summaryCreditAccountsArr);
  }

  formatDate(dob: number): string {
    let dobStr = dob.toString(); // Convert integer to string
    if (dobStr.length !== 8) return ""; // Handle invalid input

    return `${dobStr.substring(0, 4)}-${dobStr.substring(
      4,
      6
    )}-${dobStr.substring(6, 8)}`;
  }

  updateNeedle() {
    const minScore = 300;
    const maxScore = 900;
    const minAngle = -90;
    const maxAngle = 90;
    // Calculate needle angle based on credit score
    this.needleRotation =
      ((this.creditScoreExperian - minScore) / (maxScore - minScore)) *
        (maxAngle - minAngle) +
      minAngle;
  }

  groupAccountHistory() {
    const grouped = {};

    this.caisAccountHistory.forEach((entry) => {
      entry.uniqueYears = Array.from(new Set(entry.map((item) => item.Year))); // Sorting in descending order
      entry.yearData = [];

      entry.uniqueYears.forEach((item) => {
        var newmonth = [
          { id: 1, value: "Jan", data: undefined },
          { id: 2, value: "Feb", data: undefined },
          { id: 3, value: "Mar", data: undefined },
          { id: 4, value: "Apr", data: undefined },
          { id: 5, value: "May", data: undefined },
          { id: 6, value: "Jun", data: undefined },
          { id: 7, value: "Jul", data: undefined },
          { id: 8, value: "Aug", data: undefined },
          { id: 9, value: "Sep", data: undefined },
          { id: 10, value: "Oct", data: undefined },
          { id: 11, value: "Nov", data: undefined },
          { id: 12, value: "Dec", data: undefined },
        ];
        entry.yearData.push({ Year: item, Month: newmonth });
      });

      entry.forEach((item) => {
        var _find = entry.yearData.find((x) => x.Year === item.Year);
        var _findMonth = _find.Month.find((x) => x.id === item.Month);
        if (_findMonth) {
          _findMonth.data = item.Days_Past_Due;
        }
      });
    });
    console.log("caisAccountHistory after add", this.caisAccountHistory);
  }

  printSection(sectionId: string) {
    const printContents = document.getElementById(sectionId)?.innerHTML;
    if (!printContents) return;

    const originalStyles = document.head.innerHTML; // Capture current styles
    const newWindow = window.open("", "", "width=800,height=600");

    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>${originalStyles}</head>
          <body onload="window.print();window.close();">
            ${printContents}
          </body>
        </html>
      `);
      newWindow.document.close();
    }
  }
}
